import React from 'react';

import { usePriceRowContext } from '../../../price-row-context';

import { IconVerfied } from '@prisjakt/ui/icon/verified';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import { Tooltip } from '@prisjakt/ui/tooltip';
import { Direction } from '@prisjakt/ui';
import { Badge } from '@prisjakt/ui/badge';
import { MediumUp, MobileOnly } from 'src/ui/block';
import { useAppContext } from 'src/components/app-context';

type Props = {
  className?: string;
};

export const AuthorizedDealerBadge: React.FC<Props> = ({ className }) => {
  const { offer, product } = usePriceRowContext();
  const { t } = useAppContext();

  const content = (
    <>
      <MobileOnly>
        <Badge circular color="BLUE" icon={IconVerfied} />
      </MobileOnly>

      <MediumUp>
        <Badge
          color="BLUE"
          icon={IconVerfied}
          text={
            <BodySmallText weight={600} style={{ fontSize: 12 }}>
              {t('store', 'brand.recommended-retailer')}
            </BodySmallText>
          }
        />
      </MediumUp>
    </>
  );

  if (!product.brand || !offer.store) {
    return content;
  }

  return (
    <Tooltip
      className={className}
      title={t('store', 'store.recommended-retailer-brand', {
        brand: product.brand.name,
        store: offer.store.name,
      })}
      placement={Direction.Left}
    >
      {content}
    </Tooltip>
  );
};
